export default "__VITE_ASSET__1u71ohkF__"